<template>
  <div class="bg-gray-50 p-5" :class="isOpen ? 'pb-0.5' : 'pb-5'">
    <div
      class="-mb-4 flex justify-between"
      :class="{ 'border-b': isOpen }"
      @click="toggleOpen"
    >
      <lf-h3 class="pt-2 pb-6">
        {{ title || $t("DEALS.DEAL_PROGRESS.UNDERWRITING.SUBMITTED_DATA") }}
      </lf-h3>
      <dropdown-chevron
        data-cy="submitted-data-toggle"
        class="translate-y-2-5 transform"
        :is-open="isOpen"
      />
    </div>
    <div v-if="isOpen" class="my-5 pt-5">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps({
  title: {
    type: String,
    default: "",
  },
});
const isOpen = ref(false);
const toggleOpen = () => (isOpen.value = !isOpen.value);
</script>
